<div class="login2background" style="background-image: url(assets/img/global/fundo_login.jpg)">
  <div class="main-content container-fluid">
    <div class="splash-container">
      <div class="card">
        <div class="card-header d-inline p-3">
          <img src="assets/img/global/logo.png" alt="">
        </div>
        <div class="card-body">
          <form id="login-form">
            <div *ngIf="msgs" class="alert alert-danger text-center" role="alert">
              {{msgs}}
            </div>
            <div class="col-auto">
              <label class="sr-only" for="email">e-mail</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text"><em class="fa fa-user"></em></div>
                </div>
                <input [imask]="maskConfig" unmask="true" type="text" class="form-control" name="email"
                  [(ngModel)]="email" placeholder="Informe o seu e-mail de acesso ou CPF">
              </div>
            </div>

            <div class="col-auto pt-3">
              <label class="sr-only" for="senha">Senha</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text"><em class="fa fa-lock"></em></div>
                </div>
                <input type="password" class="form-control" name="senha" [(ngModel)]="senha"
                  placeholder="Infome sua senha">
              </div>
            </div>

            <div class="row p-3">
              <div class="col-12">
                <button (click)="fazerLogin()" class="btn btn-block btn-primary">Entrar</button>
              </div>
            </div>

            <div class="col-auto text-center pt-3">
              <button type="button" class="btn btn-link" (click)="recuperarSenha()">Esqueceu sua senha?</button>
              <span class="mx-2">·</span>
              <button type="button" class="btn btn-link" (click)="registroUsuario()">Não possui uma conta?</button>
              <button *ngIf="sistema === 'terceiro-setor'" type="button" class="btn btn-link"
                (click)="loginEntidade()">Pertence a uma entidade?</button>
            </div>

            <div class="col-auto text-center pt-3">
              <span class="small text-muted">Versão <span id="eddy_login-versao">{{mostrarVersao()}}</span></span>
            </div>
          </form>
        </div>
        <div class="card-footer">
          <div class="text-center">
            <span class="small text-muted">
              Este sistema usa cookies e outras tecnologias semelhantes para armazenar informações de login para
              tratativas de segurança e otimizar o uso do sistema, ao fazer login você concorda com estes termos.
              <a target="_blank" href="http://eddydata.com.br/empresa/protecao-de-dados">Saiba mais</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>